import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Table, TableBody, Typography } from '@material-ui/core';
import _ from 'lodash';
import ApplicationTableHeader from './ApplicationTableHeader';
import ApplicationTableRow from './ApplicationTableRow';
import numberFormatter from '../../../utils/numberFormatter';
import ValidationError from './ValidationError';

class ValueField extends React.Component {
  state = {
    selectedItems: [],
  }

  handleClick = application => {
    const newItems = this.state.selectedItems.includes(application)
      ? this.state.selectedItems.filter(a => a !== application)
      : [...this.state.selectedItems, application];

    this.setState({ selectedItems: newItems });

    this.props.input.onChange(newItems);
    this.props.input.onBlur();
  }

  renderTable = (applications, categoriesEnabled, subcategoriesEnabled) => (
    <Table className="projects-table">
      <ApplicationTableHeader categoriesEnabled={categoriesEnabled} subcategoriesEnabled={subcategoriesEnabled} leftAction />
      <TableBody>
        {applications.map(application => (
          <ApplicationTableRow
            key={application.id}
            application={application}
            leftAction={<Checkbox
              checked={this.state.selectedItems.includes(application.id)}
              onClick={() => this.handleClick(application.id)}
              value={application.id}
              color="primary"
              disabled={this.props.disabled}
            />}
            categoriesEnabled={categoriesEnabled}
            subcategoriesEnabled={subcategoriesEnabled}
          />)
        )}
      </TableBody>
    </Table>);

  render() {
    const { meta: { touched, error }, values, max, groupByDistricts, districts } = this.props;
    const categoriesEnabled = values.filter(a => a.category !== null).length > 0;
    const subcategoriesEnabled = values.filter(a => a.subcategory !== null).length > 0;

    return (
      <React.Fragment>
        <div className="box">
          <div className="col-sm-12">
            <Typography variant="body2" style={{ marginBottom: 30 }}>Rozdysponuj środki pomiędzy wybrane projekty. Maksymalna kwota do rozdysponowania to <strong>{numberFormatter.format(max)}</strong> zł</Typography>
            {groupByDistricts || categoriesEnabled
              ? _(values)
                .groupBy(x => groupByDistricts ? x.district : x.category)
                .map((value, key) => ({ key, applications: value}))
                .sortBy(x => groupByDistricts ? districts.indexOf(x.key) : ['key'])
                .value()
                .map(x => (
                  <div key={x.key} style={{ marginBottom: 30 }}>
                    <h3 className="category"><i className="fa fa-bookmark" /> <span>{groupByDistricts ? 'Obszar' : 'Kategoria'}</span> {x.key}</h3>
                    {this.renderTable(x.applications, groupByDistricts ? categoriesEnabled : false, subcategoriesEnabled)}
                  </div>))
            : this.renderTable(values, categoriesEnabled, subcategoriesEnabled)}
          
            <Typography variant="body2">Kwota pozostała do wykorzystania {numberFormatter.format(this.props.max - this.props.sum < 0 ? 0 : this.props.max - this.props.sum)}&nbsp;zł</Typography>
        </div>
      </div>

      {error && touched ? <ValidationError error={error} /> : null}
      </React.Fragment>);
  }
}

ValueField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  values: PropTypes.array.isRequired,
  categoriesChoiceLimits: PropTypes.array,
  max: PropTypes.number.isRequired,
  sum: PropTypes.number.isRequired,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,
};

export default ValueField;



// WEBPACK FOOTER //
// ./src/components/budget/types/ValueField.js